import React, { useState, useEffect } from "react";
import { useDebounce } from "use-debounce";
import { FiCloud } from "react-icons/fi";
import { BsFillExclamationCircleFill } from "react-icons/bs";
import { CiGlobe, CiEdit } from "react-icons/ci";
import { LuMapPin, LuNavigation2 } from "react-icons/lu";
import { BiMapPin } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../assets/css/Dashboard.css";
import {
  getHotSpotRegionalState,
  getHotSpotKebele,
  getHotSpotWoreda,
  getHotSpotZone
} from "../Services/apiService";
import { useRole } from "./RoleContext";
import "../assets/css/DataSourcePanel.css";
import { getRegionalStates, getZones, getWoredas, getKebeles, updateEndemicity, clearHotspotCache } from "../Services/apiService";
const DataSourcePanel = ({ onRefresh }) => {
  const { role } = useRole();
  const isAdmin = ["admin", "superadmin"].includes(role?.toLowerCase());
  const [regionalCount, setRegionalCount] = useState();
  const [zoneCount, setZoneCount] = useState();
  const [woredaCount, setWoredaCount] = useState();
  const [kebeleCount, setKebeleCount] = useState();
  const [selectedType, setSelectedType] = useState(null);
  const [modalData, setModalData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [editEndemicity, setEditEndemicity] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounce(searchTerm, 500);
  const [loading, setLoading] = useState(false);
  const [zonesList, setZonesList] = useState([]);
  const [woredasList, setWoredasList] = useState([]);
  const [regionalData, setRegionalData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [woredaData, setWoredaData] = useState([]);
  const [kebeleData, setKebeleData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      let regionalState = await getRegionalStates();
      setRegionalData(regionalState);
      let zone = await getZones();
      setZoneData(zone);
      let woreda = await getWoredas();
      setWoredaData(woreda);
      let kebele = await getKebeles();
      setKebeleData(kebele);
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  const regionalStateData = regionalData.map((w) => w.regionalState);
  const [selectedRegionalState, setSelectedRegionalState] = useState("");
  useEffect(() => {
    if (selectedRegionalState && selectedRegionalState.trim() !== "") {
      const isRegionalState = regionalStateData.some(
        (r) =>
          r.trim().toLowerCase() === selectedRegionalState.trim().toLowerCase()
      );
      if (isRegionalState) {
      } else {
        const matchingZone = zoneData.find(
          (z) =>
            z.Zone.trim().toLowerCase() ===
            selectedRegionalState.trim().toLowerCase()
        );

        if (matchingZone) {
          const regionName = matchingZone.regionalState.trim();
        }
      }
    }
  }, [selectedRegionalState]);

  const handleCardClick = async (type) => {
    setSelectedType(type);
    setIsModalOpen(true);

    try {
      setLoading(true);
      let config = { title: "", columns: [], rows: [] };
      if (type === "regionalState") {
        const res = await getHotSpotRegionalState();
        config = {
          title: "Disease Hotspots by Regional State",
          columns: [
            { key: "regionalState", label: "Regional State" },
            { key: "capitalCity", label: "Capital City" },
            { key: "endemicity", label: "Endemicity" },
            { key: "Data Source", label: "Data Source" },
          ],
          rows: res.map((r) => ({
            regionalState: r.regionalState || "N/A",
            capitalCity: r.capitalCity || "N/A",
            endemicity: r.endemicity || "No data",
            "Data Source": "ESPN",
            _id: r._id,
          })),
        };
      } else if (type === "zone") {
        const res = await getHotSpotZone();
        config = {
          title: "Disease Hotspots by Zones",
          columns: [
            { key: "zone", label: "Zone" },
            { key: "regionalState", label: "Regional State" },
            { key: "endemicity", label: "Endemicity" },
            { key: "Data Source", label: "Data Source" },
          ],
          rows: res.map((z) => ({
            zone: z.zone || "N/A",
            regionalState: z.regionalState || "N/A",
            endemicity: z.endemicity || "No data",
            "Data Source": "ESPN",
            _id: z._id,
          })),
        };
      } else if (type === "woreda") {
        const res = await getHotSpotWoreda();
        config = {
          title: "Disease Hotspots by Woreda",
          columns: [
            { key: "woreda", label: "Woreda" },
            { key: "zone", label: "Zone" },
            { key: "regionalState", label: "Regional State" },
            { key: "endemicity", label: "Endemicity" },
            { key: "Data Source", label: "Data Source" },
          ],
          rows: res.map((w) => ({
            woreda: w.woreda || "N/A",
            zone: w.zone || "N/A",
            regionalState: w.regionalState || "N/A",
            endemicity: w.endemicity || "No data",
            "Data Source": "ESPN",
            _id: w._id,
          })),
        };
      } else if (type === "kebele") {
        const res = await getHotSpotKebele();
        config = {
          title: "Disease Hotspots by Kebele",
          columns: [
            { key: "kebele", label: "Kebele" },
            { key: "woreda", label: "Woreda" },
            { key: "zone", label: "Zone" },
            { key: "regionalState", label: "Regional State" },
            { key: "endemicity", label: "Endemicity" },
            { key: "Data Source", label: "Data Source" },
          ],
          rows: res.map((k) => ({
            kebele: k.kebele || "N/A",
            woreda: k.woreda || "N/A",
            zone: k.zone || "N/A",
            regionalState: k.regionalState || "N/A",
            endemicity: k.endemicity || "No data",
            "Data Source": "ESPN",
            _id: k._id,
          })),
        };
      }

      setModalData(config);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredRows =
    modalData.rows?.filter((row) =>
      Object.values(row)
        .join(" ")
        .toLowerCase()
        .includes(debouncedSearchTerm.toLowerCase())
    ) || [];

  const totalPages = Math.ceil((filteredRows.length || 0) / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedRows = filteredRows.slice(startIndex, endIndex) || [];

  const handleCancelEdit = () => {
    setEditRowId(null);
    setEditEndemicity("");
  };
  const handleInlineEdit = (row) => {
    setEditRowId(row._id);
    setEditEndemicity(row.endemicity || "");
  };

  const handleInlineSave = async (rowId, dbName, endemicity) => {
    try {
      let res = null;
      switch (selectedType) {
        case "regionalState":
          res = await updateEndemicity({ rowId, dbName, endemicity });
          break;
        case "zone":
          res = await updateEndemicity({ rowId, dbName, endemicity });
          break;
        case "woreda":
          res = await updateEndemicity({ rowId, dbName, endemicity });
          break;
        case "kebele":
          res = await updateEndemicity({ rowId, dbName, endemicity });
          break;
        default:
          console.warn("Unknown type:", selectedType);
      }

      if (res && res.status === 200) {
        toast.success(res?.data?.message);
        setEditRowId(null);
        setEditEndemicity("");
        const updatedRows = modalData.rows.map((row) =>
          row._id === rowId ? { ...row, endemicity } : row
        );
        setModalData((prev) => ({ ...prev, rows: updatedRows }));
        clearHotspotCache();
        if (onRefresh) onRefresh();
      }
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Error updating Endemicity!");
    }
  };

  const [showAddModal, setShowAddModal] = useState(false);

  useEffect(() => {
    if (showAddModal) {
      const fetchZonesAndWoredas = async () => {
        try {
          const [zonesRes, woredasRes] = await Promise.all([
            getHotSpotZone(),
            getHotSpotWoreda(),
          ]);
          setZonesList(zonesRes || []);
          setWoredasList(woredasRes || []);
        } catch (error) {
          console.error("Error fetching zone/woreda lists:", error);
          toast.error("Failed to load zones or woredas.");
        }
      };

      fetchZonesAndWoredas();
    }
  }, [showAddModal]);

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearchTerm]);

  const loader = [
    {
      id: "1",
    },
    {
      id: "2",
    },
    {
      id: "3",
    },
    {
      id: "4",
    },
  ];
  useEffect(() => {
    async function loadCounts() {
      try {
        setLoading(true);
        const [regionalRes, zoneRes, woredaRes, kebeleRes] = await Promise.all([
          getHotSpotRegionalState(),
          getHotSpotZone(),
          getHotSpotWoreda(),
          getHotSpotKebele(),
        ]);

        setRegionalCount(regionalRes?.length || 0);
        setZoneCount(zoneRes?.length || 0);
        setWoredaCount(woredaRes?.length || 0);
        setKebeleCount(kebeleRes?.length || 0);
      } catch (err) {
        console.error("Failed to load hotspot counts:", err);
      } finally {
        setLoading(false);
      }
    }

    loadCounts();
  }, []);

  return (
    <aside className="aside-panel">
      <ToastContainer />
      <div className="panel-content">
        <div className="details-header">
          <div className="details-header-content">
            <div className="details-icon">
              <FiCloud className="icon" />
            </div>
            <div className="details-text">
              <div className="details-title">API Data Sources</div>
              <div className="details-subtitle">Location: Ethiopia</div>
            </div>
          </div>
        </div>
        <div className="panel-content">
          <div className="data-sources-container">
            <div className="tags-container">
              <span className="tag tag-wash">Ethiopia</span>
              <span className="tag tag-social">Schistosomiasis</span>
              <span className="tag tag-upload">Endemicity</span>
            </div>
          </div>
          <div className="data-sources">
            <div className="sources-header">
              <p className="sources-title">Data Sources</p>
            </div>
            {loading && (
              <>
                {loader.map((item) => (
                  <div key={item.id} className="data-sources-cards">
                    <div className="data-card-skeleton ">
                      <div className="card-content">
                        <div className="card-header">
                          <div className="card-icon regional-icon"></div>
                          <div>
                            <div className="card-title-skeleton"></div>
                            <div className="card-subtitle-skeleton"></div>
                          </div>
                        </div>
                        <div className="status-badge-skeleton"></div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
            {!loading && (
              <>
                <div className="data-sources-cards">
                  <div
                    className="data-card clickable"
                    onClick={() => handleCardClick("regionalState")}
                  >
                    <div className="card-content">
                      <div className="card-header">
                        <div className="card-icon regional-icon">
                          <CiGlobe className="icon" />
                        </div>
                        <div>
                          <div className="card-title">Regional State</div>
                          <div className="card-subtitle">
                            {regionalCount} records
                          </div>
                        </div>
                      </div>
                      <div className="status-badge">prevalence</div>
                    </div>
                  </div>
                  <div
                    className="data-card clickable"
                    onClick={() => handleCardClick("zone")}
                  >
                    <div className="card-content">
                      <div className="card-header">
                        <div className="card-icon social-icon">
                          <LuMapPin className="icon" />
                        </div>
                        <div>
                          <div className="card-title">Zones</div>
                          <div className="card-subtitle">
                            {zoneCount} records
                          </div>
                        </div>
                      </div>
                      <div className="status-badge">prevalence</div>
                    </div>
                  </div>
                  <div
                    className="data-card clickable"
                    onClick={() => handleCardClick("woreda")}
                  >
                    <div className="card-content">
                      <div className="card-header">
                        <div className="card-icon upload-icon">
                          <LuNavigation2 className="icon" />
                        </div>
                        <div>
                          <div className="card-title">Woreda</div>
                          <div className="card-subtitle">
                            {woredaCount} records
                          </div>
                        </div>
                      </div>
                      <div className="status-badge">prevalence</div>
                    </div>
                  </div>
                  <div
                    className="data-card clickable"
                    onClick={() => handleCardClick("kebele")}
                  >
                    <div className="card-content">
                      <div className="card-header">
                        <div className="card-icon record-icon">
                          <BiMapPin className="icon" />
                        </div>
                        <div>
                          <div className="card-title">Kebele</div>
                          <div className="card-subtitle">
                            {kebeleCount} records
                          </div>
                        </div>
                      </div>
                      <div className="status-badge">prevalence</div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          {isModalOpen && (
            <div
              className="modal-overlay"
              onClick={(e) => {
                if (e.target === e.currentTarget) {
                  setIsModalOpen(false);
                  setModalData([]);
                  setSelectedType(null);
                }
              }}
            >
              <div className="modal-container">
                <div className="modal-header">
                  <p>{modalData.title}</p>
                  <div className="search-bar-container">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="search-bar"
                    />
                  </div>
                  <button
                    className="close-btn"
                    title="Close"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsModalOpen(false);
                      setModalData([]);
                      setSelectedType(null);
                    }}
                  >
                    ×
                  </button>
                </div>
                <hr />
                <div className="modal-body">
                  {modalData.rows && modalData.rows.length > 0 ? (
                    <>
                      <table className="data-source-table">
                        <thead>
                          <tr>
                            {modalData.columns.map((col) => (
                              <th key={col.key}>{col.label}</th>
                            ))}
                            {isAdmin && <th>Action</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {paginatedRows.map((row) => (
                            <tr key={row._id}>
                              {modalData.columns.map((col) => (
                                <td key={col.key}>
                                  {col.key === "endemicity" &&
                                    editRowId === row._id ? (
                                    <select
                                      value={editEndemicity}
                                      onChange={(e) =>
                                        setEditEndemicity(e.target.value)
                                      }
                                      className="endemicity-dropdown"
                                    >
                                      <option value="<1% prevalence (non-endemic)">
                                        &lt;1% prevalence (non-endemic)
                                      </option>
                                      <option value="1 - 9.9% prevalence (low)">
                                        1 - 9.9% prevalence (low)
                                      </option>
                                      <option value="10 - 49.9% prevalence (moderate)">
                                        10 - 49.9% prevalence (moderate)
                                      </option>
                                      <option value=">=50% prevalence (high)">
                                        &gt;=50% prevalence (high)
                                      </option>
                                      <option value="No Data">No Data</option>
                                    </select>
                                  ) : col.key === "Data Source" ? (
                                    <a
                                      href="https://espen.afro.who.int/maps-data/diseases/schistosomiasis?combine=&items_per_page=24&country_filter%5BET%5D=ET#schby-country--maps"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "#2563eb", textDecoration: "underline", cursor: "pointer" }}
                                    >
                                      {row[col.key]}
                                    </a>
                                  ) : (
                                    row[col.key]
                                  )}
                                </td>
                              ))}

                              {isAdmin && (
                                <td>
                                  {editRowId === row._id ? (
                                    <>
                                      <button
                                        className="save-btn"
                                        onClick={() =>
                                          handleInlineSave(row._id, selectedType, editEndemicity)
                                        }
                                      >
                                        Save
                                      </button>
                                      <button
                                        className="cancel-btn"
                                        onClick={() =>
                                          handleCancelEdit(row._id)
                                        }
                                      >
                                        Cancel
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="edit-btn"
                                      onClick={() => handleInlineEdit(row)}
                                    >
                                      <CiEdit />
                                    </button>
                                  )}
                                </td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      {modalData?.rows &&
                        modalData.rows.length > 0 &&
                        totalPages >= 1 ? (
                        <div className="paginationContainer">
                          <button
                            className="paginationButton"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => p - 1)}
                          >
                            Prev
                          </button>
                          <span className="paginationInfo">
                            Page {currentPage} of {totalPages}
                          </span>
                          <button
                            className="paginationButton"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((p) => p + 1)}
                          >
                            Next
                          </button>
                        </div>
                      ) : (
                        <div className="no-data">
                          <BsFillExclamationCircleFill className="no-data-icon" />
                          <p>No data found.</p>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      {modalData.rows && modalData.rows.length == 0 && (
                        <table className="data-source-table">
                          <thead>
                            <tr>
                              {modalData.columns.map((col) => (
                                <th key={col.key}>{col.label}</th>
                              ))}
                              {isAdmin && <th>Action</th>}
                            </tr>
                          </thead>
                        </table>
                      )}
                      <div className="no-data">
                        <BsFillExclamationCircleFill className="no-data-icon" />
                        <p>No data found.</p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="region-banner">
            <p className="region-text">All data is filtered for Ethiopia</p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default DataSourcePanel;
